import { grey } from "@mui/material/colors";

const styles = {
  backIcon: {
    border: `1.5px solid ${grey[500]}`,
    fontSize: "0.8rem",
  },
  button: {
    px: 4,
    height: "40px",
  },
  cancelButton: {
    backgroundColor: "#F1F2EF",
    color: "primary.main",
  },
  selectedMenuItem: {
    pl: 1.5,
    borderLeftWidth: "3px",
    borderLeftStyle: "solid",
    borderLeftColor: "primary.main",
    color: "primary.main",
  },
  menuText: {
    fontSize: { xs: "14px", lg: "16px" },
  },
  drawer: {
    borderRight: `1px solid ${grey[300]}`,
    pt: 2,
    pb: 10,
  },
  settingContainer: {
    px: { xs: 0, sm: 4 },
    py: 4,
  },
  pauseFormControl: {
    "& .MuiFormControlLabel-label": {
      fontWeight: 600,
      fontSize: "15px",
    },
  },
  fab: {
    position: "fixed",
    bottom: 15,
    right: 15,
    textTransform: "none",
    fontSize: 15,
    p: 2,
  },
  activeFab: {
    backgroundColor: "primary.main",
    color: "white",

    "&:hover": {
      backgroundColor: "primary.dark",
    },
  },
  inactiveFab: {
    backgroundColor: grey[400],
    color: grey[700],
    "&:hover": {
      backgroundColor: grey[400],
    },
  },
};

export default styles;
